import { CommonButton } from '@Components/common/Button';
import { CommonSelect } from '@Components/common/CommonSelect';
import styled from 'styled-components';
import { mq } from 'stylesheets/utils';
export const FilterWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  margin-top: 24px;
  flex-wrap: wrap;
`;

export const SelectItem = styled(CommonSelect)`
  max-width: 200px;
  margin-bottom: 0;
  ${mq(576)} {
    max-width: unset;
    width: 100%;
  }
`;

export const Reset = styled(CommonButton)`
  min-width: 120px;
  max-width: 120px;
  min-height: 40px;
`;

export const Card = styled.form`
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.colors.auth.lightPurple};
  background-color: ${({ theme }) => theme.colors.filterCardBg};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
  /* align-items: center; */
  /* max-width: 320px; */
  ${mq(1200)} {
  }
  ${mq(992)} {
    padding: 16px;
    margin-bottom: 16px;
  }
  ${mq(768)} {
    margin-bottom: 20px;
    max-width: unset;
  }
`;

export const CarSelects = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  ${SelectItem} {
    margin: 0 12px 16px 0;
    max-width: 140px;
    min-width: 140px;
  }
  ${mq(992)} {
    margin-bottom: 16px;
    flex-direction: column;
    ${SelectItem} {
      max-width: unset;
      width: 100%;
    }
  }
  /* flex-wrap: wrap; */
`;

export const Title = styled.h6`
  font-size: ${({ theme }) => theme.fontsizes.h6};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.black};
  margin-bottom: 16px;
`;

export const Button = styled(CommonButton)`
  width: 180px;
  margin-left: auto;
`;
